import { UserBookingsModalComponent } from "./user-bookings-modal/user-bookings-modal.component";
import { UserDetailsComponent } from "./user-details/user-details.component";
import { UserSearchBarComponent } from "./user-search-bar/user-search-bar.component";

export {
  UserBookingsModalComponent,
  UserDetailsComponent,
  UserSearchBarComponent,
};

export const userComponents = [
  UserBookingsModalComponent,
  UserDetailsComponent,
  UserSearchBarComponent,
]
